export function setDatosRegio(state, payload){
    
    state.datosphp = payload.data
    state.error= false
 
}
export function datosregioError (state, payload){
    state.error = true
    state.errorMessage = payload

}